import React, { useRef, createContext, useContext, useState, useEffect } from 'react';
import { PokedexContext } from './pokemonData';
import { AppConfigContext } from '../../Config/App';
import { useNavigate, useParams } from 'react-router-dom';
import Axios from 'axios';
import { getUserFromLocalStorage } from '../../utils/localStorage';

export const BuildContext = createContext();

export const BuildProvider = ({ children }) => {
    const { api_url, navigate_to, uri_segment } = useContext(AppConfigContext);
    const [buildData, setBuildData] = useState();
    const [btnPressed, setBtnPressed] = useState();
    const { pokemonData, getSprite, fetchPokemon } = useContext(PokedexContext);
    const [teammates, setTeammates] = useState();
    const { viewingID, editingID } = useParams();
    const [isLoaded, setIsLoaded] = useState(false);
    const user_session = getUserFromLocalStorage();
    const navigate = useNavigate();

    //Ponto 9 Duplicar estas variáveis
    const [pokemonPersonalities, setPokemonPersonalities] = useState();
    const [pokemonHeldItems, setPokemonHeldItems] = useState();
    const [pokemonGears, setPokemonGears] = useState();
    const [pokemonHiddenSkills, setPokemonHiddenSkills] = useState([]);

    const [buildDataFromDB, setBuildDataFromDB] = useState();
    const [buildMode, setBuildMode] = useState();

    const buildTitle = useRef();
    const generalNotes = useRef();
    const abilitiesNotes = useRef();
    const personalitiesNotes = useRef();
    const heldItemsNotes = useRef();
    const gearNotes = useRef();
    const hiddenSkillsNotes = useRef();

    const teammate_2 = useRef();
    const teammate_3 = useRef();
    const teammate_5 = useRef();
    const teammate_6 = useRef();

    const ability_1 = useRef();
    const ability_2 = useRef();
    const ability_3 = useRef();
    const ability_4 = useRef();
    const ability_5 = useRef();
    const ability_6 = useRef();
    const ability_7 = useRef();
    const ability_8 = useRef();

    const personality_1 = useRef();
    const personality_2 = useRef();
    const personality_3 = useRef();
    const personality_4 = useRef();

    const heldItem_1 = useRef();
    const heldItem_2 = useRef();
    const heldItem_3 = useRef();
    const heldItem_4 = useRef();

    const gear_1 = useRef();
    const gear_2 = useRef();
    const gear_3 = useRef();
    const gear_4 = useRef();

    const hiddenSkill_1 = useRef();
    const hiddenSkill_2 = useRef();
    const hiddenSkill_3 = useRef();
    const hiddenSkill_4 = useRef();
    const hiddenSkill_5 = useRef();
    const hiddenSkill_6 = useRef();
    const hiddenSkill_7 = useRef();
    const hiddenSkill_8 = useRef();
    const hiddenSkill_9 = useRef();
    const hiddenSkill_10 = useRef();
    const hiddenSkill_11 = useRef();
    const hiddenSkill_12 = useRef();

    const gameVersion = useRef();

    //Ponto extra 1 duplicar o useEffect para chamar os dados
    useEffect(() => {
        if (viewingID) {
            getPokemonData('viewing', viewingID);
        } else if (editingID && !user_session.user_id) {
            navigate(navigate_to('auth'));
        } else if (editingID && user_session.user_id) {
            Axios.get(api_url(`checkBuildOwnership/${editingID}/${user_session.user_id}`))
                .then((response) => {
                    response.status === 200 ? getPokemonData('editing', editingID) : redirectToNewBuild();
                })
                .catch((err) => {
                    console.log(err.code, err.stack, err.message);
                });
        } else if (uri_segment() === 'new-build') {
            redirectToNewBuild();
        }
        loadPage();
        // eslint-disable-next-line
    }, [viewingID, editingID]);

    const redirectToNewBuild = () => {
        clearBuild();
        fetchPokemon(643);
        setBuildMode('building');
    };

    function getPokemonData(mode, build_id) {
        clearBuild();

        Axios.get(api_url(`build/${build_id}`))
            .then((response) => {
                if (response.status === 200) {
                    fetchPokemon(response.data.pokemon_id);
                    setBuildDataFromDB(response.data);
                    setBuildMode(mode);
                } else {
                    navigate(navigate_to('new-build'));
                }
            })
            .catch((err) => {
                console.log(err.code, err.stack, err.message);
            });

        loadPage();
    }

    const loadPage = () => {
        setIsLoaded(true);
        // eslint-disable-next-line
    };

    useEffect(() => {
        updateBuild();
        // eslint-disable-next-line
    }, [teammates, pokemonPersonalities, pokemonHeldItems, pokemonHiddenSkills, pokemonGears]);

    function getBtnKey(key) {
        setBtnPressed(key);
        updateBuild();
    }

    function updateBuildTitle(title) {
        buildTitle.current = title;
        if (editingID && buildDataFromDB) {
            buildDataFromDB.title = buildTitle.current;
        }
        updateBuild();
    }

    function updateGeneralNotes(text) {
        generalNotes.current = text;
        if (editingID && buildDataFromDB) {
            buildDataFromDB.notes.general_notes = generalNotes.current;
        }
        updateBuild();
    }

    function updateAbilitiesNotes(text) {
        abilitiesNotes.current = text;
        if (editingID && buildDataFromDB) {
            buildDataFromDB.notes.abilities_notes = abilitiesNotes.current;
        }
        updateBuild();
    }

    function updatePersonalitiesNotes(text) {
        personalitiesNotes.current = text;
        if (editingID && buildDataFromDB) {
            buildDataFromDB.notes.personalities_notes = personalitiesNotes.current;
        }
        updateBuild();
    }

    function updateHeldItemsNotes(text) {
        heldItemsNotes.current = text;
        if (editingID && buildDataFromDB) {
            buildDataFromDB.notes.held_items_notes = heldItemsNotes.current;
        }
        updateBuild();
    }

    function updateGearNotes(text) {
        gearNotes.current = text;
        if (editingID && buildDataFromDB) {
            buildDataFromDB.notes.gear_notes = gearNotes.current;
        }
        updateBuild();
    }

    function updateHiddenSkillsNotes(text) {
        hiddenSkillsNotes.current = text;
        if (editingID && buildDataFromDB) {
            buildDataFromDB.notes.hidden_skills_notes = hiddenSkillsNotes.current;
        }
        updateBuild();
    }

    function updateGameVersion(version) {
        gameVersion.current = version;
        if (editingID && buildDataFromDB) {
            buildDataFromDB.gameVersion = gameVersion.current;
        }
    }

    //Ponto 10 Extrair as variáveis todas para além das abilities
    function updateBuild() {
        setBuildData({
            id: pokemonData.id,
            name: pokemonData.name.pokeland,
            title: buildTitle.current,
            picture: pokemonData.sprites.pokeland,
            abilities: {
                ability_1: ability_1.current,
                ability_2: ability_2.current,
                ability_3: ability_3.current,
                ability_4: ability_4.current,
                ability_5: ability_5.current,
                ability_6: ability_6.current,
                ability_7: ability_7.current,
                ability_8: ability_8.current,
            },
            personalities: pokemonPersonalities,
            heldItems: pokemonHeldItems,
            teammates: teammates,
            hiddenSkills: pokemonHiddenSkills,
            gear: pokemonGears,
            notes: {
                general: generalNotes.current,
                abilities: abilitiesNotes.current,
                personalities: personalitiesNotes.current,
                heldItems: heldItemsNotes.current,
                gear: gearNotes.current,
                hiddenSkills: hiddenSkillsNotes.current,
            },
            gameVersion: gameVersion.current ? gameVersion.current : 'en',
        });
    }

    //Ponto 11 Apagar as variavies todas menos as abilities
    function updateAbility(ability) {
        if (btnPressed === 1) ability_1.current = ability;
        if (btnPressed === 2) ability_2.current = ability;
        if (btnPressed === 3) ability_3.current = ability;
        if (btnPressed === 4) ability_4.current = ability;
        if (btnPressed === 5) ability_5.current = ability;
        if (btnPressed === 6) ability_6.current = ability;
        if (btnPressed === 7) ability_7.current = ability;
        if (btnPressed === 8) ability_8.current = ability;

        if (editingID) {
            if (btnPressed === 1) buildDataFromDB.abilities.ability_1 = ability_1.current;
            if (btnPressed === 2) buildDataFromDB.abilities.ability_2 = ability_2.current;
            if (btnPressed === 3) buildDataFromDB.abilities.ability_3 = ability_3.current;
            if (btnPressed === 4) buildDataFromDB.abilities.ability_4 = ability_4.current;
            if (btnPressed === 5) buildDataFromDB.abilities.ability_5 = ability_5.current;
            if (btnPressed === 6) buildDataFromDB.abilities.ability_6 = ability_6.current;
            if (btnPressed === 7) buildDataFromDB.abilities.ability_7 = ability_7.current;
            if (btnPressed === 8) buildDataFromDB.abilities.ability_8 = ability_8.current;
        }
        updateBuild();
        //setBuildMode('building')
    }

    function updateTeammate(pokemonID) {
        if (btnPressed === 2) teammate_2.current = getSprite(pokemonID);
        if (btnPressed === 3) teammate_3.current = getSprite(pokemonID);
        if (btnPressed === 5) teammate_5.current = getSprite(pokemonID);
        if (btnPressed === 6) teammate_6.current = getSprite(pokemonID);

        if (editingID) {
            if (btnPressed === 2) buildDataFromDB.teammates.teammate_1 = teammate_2.current;
            if (btnPressed === 3) buildDataFromDB.teammates.teammate_2 = teammate_3.current;
            if (btnPressed === 5) buildDataFromDB.teammates.teammate_3 = teammate_5.current;
            if (btnPressed === 6) buildDataFromDB.teammates.teammate_4 = teammate_6.current;
        }

        setTeammates({
            teammate_2: teammate_2.current,
            teammate_3: teammate_3.current,
            teammate_5: teammate_5.current,
            teammate_6: teammate_6.current,
        });
        updateBuild();
    }

    //Ponto 12 Duplicar esta função
    function updatePersonality(personality) {
        if (btnPressed === 1) personality_1.current = personality;
        if (btnPressed === 2) personality_2.current = personality;
        if (btnPressed === 3) personality_3.current = personality;
        if (btnPressed === 4) personality_4.current = personality;

        if (editingID) {
            if (btnPressed === 1) buildDataFromDB.personalities.personality_1 = personality_1.current;
            if (btnPressed === 2) buildDataFromDB.personalities.personality_2 = personality_2.current;
            if (btnPressed === 3) buildDataFromDB.personalities.personality_3 = personality_3.current;
            if (btnPressed === 4) buildDataFromDB.personalities.personality_4 = personality_4.current;
        }

        setPokemonPersonalities([
            personality_1.current,
            personality_2.current,
            personality_3.current,
            personality_4.current,
        ]);
        updateBuild();
    }

    function updateHeldItem(heldItem) {
        if (btnPressed === 1) heldItem_1.current = heldItem;
        if (btnPressed === 2) heldItem_2.current = heldItem;
        if (btnPressed === 3) heldItem_3.current = heldItem;
        if (btnPressed === 4) heldItem_4.current = heldItem;

        if (editingID) {
            if (btnPressed === 1) buildDataFromDB.heldItems.held_item_1 = heldItem_1.current;
            if (btnPressed === 2) buildDataFromDB.heldItems.held_item_2 = heldItem_2.current;
            if (btnPressed === 3) buildDataFromDB.heldItems.held_item_3 = heldItem_3.current;
            if (btnPressed === 4) buildDataFromDB.heldItems.held_item_4 = heldItem_4.current;
        }

        setPokemonHeldItems([heldItem_1.current, heldItem_2.current, heldItem_3.current, heldItem_4.current]);
        updateBuild();
    }

    function updateGear(gear) {
        if (btnPressed === 1) gear_1.current = gear;
        if (btnPressed === 2) gear_2.current = gear;
        if (btnPressed === 3) gear_3.current = gear;
        if (btnPressed === 4) gear_4.current = gear;

        if (editingID) {
            if (btnPressed === 1) buildDataFromDB.gear.gear_1 = gear_1.current;
            if (btnPressed === 2) buildDataFromDB.gear.gear_2 = gear_2.current;
            if (btnPressed === 3) buildDataFromDB.gear.gear_3 = gear_3.current;
            if (btnPressed === 4) buildDataFromDB.gear.gear_4 = gear_4.current;
        }

        setPokemonGears([gear_1.current, gear_2.current, gear_3.current, gear_4.current]);
        updateBuild();
    }

    function updateHiddenSkill(hiddenSkill) {
        if (btnPressed === 1) hiddenSkill_1.current = hiddenSkill;
        if (btnPressed === 2) hiddenSkill_2.current = hiddenSkill;
        if (btnPressed === 3) hiddenSkill_3.current = hiddenSkill;
        if (btnPressed === 4) hiddenSkill_4.current = hiddenSkill;
        if (btnPressed === 5) hiddenSkill_5.current = hiddenSkill;
        if (btnPressed === 6) hiddenSkill_6.current = hiddenSkill;
        if (btnPressed === 7) hiddenSkill_7.current = hiddenSkill;
        if (btnPressed === 8) hiddenSkill_8.current = hiddenSkill;
        if (btnPressed === 9) hiddenSkill_9.current = hiddenSkill;
        if (btnPressed === 10) hiddenSkill_10.current = hiddenSkill;
        if (btnPressed === 11) hiddenSkill_11.current = hiddenSkill;
        if (btnPressed === 12) hiddenSkill_12.current = hiddenSkill;

        if (editingID) {
            if (btnPressed === 1) buildDataFromDB.hiddenSkills.hidden_skill_1 = hiddenSkill_1.current;
            if (btnPressed === 2) buildDataFromDB.hiddenSkills.hidden_skill_2 = hiddenSkill_2.current;
            if (btnPressed === 3) buildDataFromDB.hiddenSkills.hidden_skill_3 = hiddenSkill_3.current;
            if (btnPressed === 4) buildDataFromDB.hiddenSkills.hidden_skill_4 = hiddenSkill_4.current;
            if (btnPressed === 5) buildDataFromDB.hiddenSkills.hidden_skill_5 = hiddenSkill_5.current;
            if (btnPressed === 6) buildDataFromDB.hiddenSkills.hidden_skill_6 = hiddenSkill_6.current;
            if (btnPressed === 7) buildDataFromDB.hiddenSkills.hidden_skill_7 = hiddenSkill_7.current;
            if (btnPressed === 8) buildDataFromDB.hiddenSkills.hidden_skill_8 = hiddenSkill_8.current;
            if (btnPressed === 9) buildDataFromDB.hiddenSkills.hidden_skill_9 = hiddenSkill_9.current;
            if (btnPressed === 10) buildDataFromDB.hiddenSkills.hidden_skill_10 = hiddenSkill_10.current;
            if (btnPressed === 11) buildDataFromDB.hiddenSkills.hidden_skill_11 = hiddenSkill_11.current;
            if (btnPressed === 12) buildDataFromDB.hiddenSkills.hidden_skill_12 = hiddenSkill_12.current;
        }

        setPokemonHiddenSkills([
            hiddenSkill_1.current,
            hiddenSkill_2.current,
            hiddenSkill_3.current,
            hiddenSkill_4.current,
            hiddenSkill_5.current,
            hiddenSkill_6.current,
            hiddenSkill_7.current,
            hiddenSkill_8.current,
            hiddenSkill_9.current,
            hiddenSkill_10.current,
            hiddenSkill_11.current,
            hiddenSkill_12.current,
        ]);
        updateBuild();
    }

    function clearBuild(isNewBuild) {
        if (isNewBuild) fetchPokemon(643);
        ability_1.current = '';
        ability_2.current = '';
        ability_3.current = '';
        ability_4.current = '';
        ability_5.current = '';
        ability_6.current = '';
        ability_7.current = '';
        ability_8.current = '';
        setPokemonPersonalities([
            (personality_1.current = ''),
            (personality_2.current = ''),
            (personality_3.current = ''),
            (personality_4.current = ''),
        ]);
        setPokemonHeldItems([
            (heldItem_1.current = ''),
            (heldItem_2.current = ''),
            (heldItem_3.current = ''),
            (heldItem_4.current = ''),
        ]);
        setPokemonGears([(gear_1.current = ''), (gear_2.current = ''), (gear_3.current = ''), (gear_4.current = '')]);
        setPokemonHiddenSkills([
            (hiddenSkill_1.current = ''),
            (hiddenSkill_2.current = ''),
            (hiddenSkill_3.current = ''),
            (hiddenSkill_4.current = ''),
            (hiddenSkill_5.current = ''),
            (hiddenSkill_6.current = ''),
            (hiddenSkill_7.current = ''),
            (hiddenSkill_8.current = ''),
            (hiddenSkill_9.current = ''),
            (hiddenSkill_10.current = ''),
            (hiddenSkill_11.current = ''),
            (hiddenSkill_12.current = ''),
        ]);
        setTeammates({
            teammate_2: (teammate_2.current = ''),
            teammate_3: (teammate_3.current = ''),
            teammate_5: (teammate_5.current = ''),
            teammate_6: (teammate_6.current = ''),
        });
        setBuildData();
    }

    const clearTeammates = () => {
        if (editingID) {
            buildDataFromDB.teammates.teammate_1 = '';
            buildDataFromDB.teammates.teammate_2 = '';
            buildDataFromDB.teammates.teammate_3 = '';
            buildDataFromDB.teammates.teammate_4 = '';
        } else {
            setTeammates({ teammate_2: '', teammate_3: '', teammate_5: '', teammate_6: '' });
        }
        updateBuild();
    };

    const clearAbilities = () => {
        if (editingID) {
            buildDataFromDB.abilities.ability_1 = '';
            buildDataFromDB.abilities.ability_2 = '';
            buildDataFromDB.abilities.ability_3 = '';
            buildDataFromDB.abilities.ability_4 = '';
            buildDataFromDB.abilities.ability_5 = '';
            buildDataFromDB.abilities.ability_6 = '';
            buildDataFromDB.abilities.ability_7 = '';
            buildDataFromDB.abilities.ability_8 = '';
        } else {
            ability_1.current = '';
            ability_2.current = '';
            ability_3.current = '';
            ability_4.current = '';
            ability_5.current = '';
            ability_6.current = '';
            ability_7.current = '';
            ability_8.current = '';
        }
        updateBuild();
    };

    const clearPersonalities = () => {
        if (editingID) {
            buildDataFromDB.personalities.personality_1 = '';
            buildDataFromDB.personalities.personality_2 = '';
            buildDataFromDB.personalities.personality_3 = '';
            buildDataFromDB.personalities.personality_4 = '';
        } else {
            setPokemonPersonalities(['', '', '', '']);
        }
        updateBuild();
    };

    const clearHeldItems = () => {
        if (editingID) {
            buildDataFromDB.heldItems.held_item_1 = '';
            buildDataFromDB.heldItems.held_item_2 = '';
            buildDataFromDB.heldItems.held_item_3 = '';
            buildDataFromDB.heldItems.held_item_4 = '';
        } else {
            setPokemonHeldItems(['', '', '', '']);
        }
        updateBuild();
    };

    const clearGear = () => {
        if (editingID) {
            buildDataFromDB.gear.gear_1 = '';
            buildDataFromDB.gear.gear_2 = '';
            buildDataFromDB.gear.gear_3 = '';
            buildDataFromDB.gear.gear_4 = '';
        } else {
            setPokemonGears(['', '', '', '']);
        }
        updateBuild();
    };

    const clearHiddenSkills = () => {
        if (editingID) {
            buildDataFromDB.hiddenSkills.hidden_skill_1 = '';
            buildDataFromDB.hiddenSkills.hidden_skill_2 = '';
            buildDataFromDB.hiddenSkills.hidden_skill_3 = '';
            buildDataFromDB.hiddenSkills.hidden_skill_4 = '';
            buildDataFromDB.hiddenSkills.hidden_skill_5 = '';
            buildDataFromDB.hiddenSkills.hidden_skill_6 = '';
            buildDataFromDB.hiddenSkills.hidden_skill_7 = '';
            buildDataFromDB.hiddenSkills.hidden_skill_8 = '';
            buildDataFromDB.hiddenSkills.hidden_skill_9 = '';
            buildDataFromDB.hiddenSkills.hidden_skill_10 = '';
            buildDataFromDB.hiddenSkills.hidden_skill_11 = '';
            buildDataFromDB.hiddenSkills.hidden_skill_12 = '';
        } else {
            setPokemonHiddenSkills(['', '', '', '', '', '', '', '', '', '', '', '']);
        }
        updateBuild();
    };

    if (isLoaded) {
        //Ponto 13 adicionar as duas novas variáveis no provider mais a função de fazer update do item
        return (
            <BuildContext.Provider
                value={{
                    buildData,
                    updateBuild,
                    getBtnKey,
                    updateAbility,
                    updateTeammate,
                    teammates,
                    updatePersonality,
                    pokemonPersonalities,
                    updateHeldItem,
                    pokemonHeldItems,
                    updateBuildTitle,
                    updateGeneralNotes,
                    updateAbilitiesNotes,
                    updatePersonalitiesNotes,
                    updateHeldItemsNotes,
                    updateHiddenSkillsNotes,
                    updateGearNotes,
                    clearBuild,
                    updateHiddenSkill,
                    pokemonHiddenSkills,
                    updateGear,
                    pokemonGears,
                    buildDataFromDB,
                    buildMode,
                    isLoaded,
                    clearTeammates,
                    clearAbilities,
                    clearPersonalities,
                    clearHeldItems,
                    clearGear,
                    clearHiddenSkills,
                    updateGameVersion,
                }}>
                {children}
            </BuildContext.Provider>
        );
    }
};
